"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedChainId = void 0;
var SupportedChainId;
(function (SupportedChainId) {
    SupportedChainId[SupportedChainId["arbitrum"] = 42161] = "arbitrum";
    SupportedChainId[SupportedChainId["mainnet"] = 1] = "mainnet";
    SupportedChainId[SupportedChainId["optimism"] = 10] = "optimism";
    SupportedChainId[SupportedChainId["polygon"] = 137] = "polygon";
    SupportedChainId[SupportedChainId["bsc"] = 56] = "bsc";
})(SupportedChainId = exports.SupportedChainId || (exports.SupportedChainId = {}));
//# sourceMappingURL=index.js.map